module.exports = __webpack_public_path__ + "static/media/home.a31d6ce3.png";